import { makeStyles } from '@mui/styles';
const complexAccordionStyles = makeStyles(({ palette, typography }) => ({
    accordionPaper: {
        background: palette.common.white,
        border: 'none',
    },
    expandIcon: {
        // TODO fix guidance linting error forbidden-style-keys
        // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
        fontSize: typography.fontSize,
    },
    accordionSummary: {
        background: palette.common.white,
        cursor: 'default',
    },
    accordionDetails: {},
}), { name: 'Common_ComplexAccordion' });
export default complexAccordionStyles;
//# sourceMappingURL=complexAccordion.styles.js.map